import { relocationValidate } from "../../application/dtos/relocation_validate";

export class relocationIndexEntity {
    constructor({ id, uuid, quantity, origin_id, destination_id, product_id, client_id, warehouse_id, pallet_origin, pallet_destination, box_origin, batch, reference, user_id, created_at, client_name, sku, origin_name, destination_name, user_name }){
        this.id = id;
        this.uuid = uuid;
        this.quantity = quantity;
        this.origin_id = origin_id;
        this.destination_id = destination_id;
        this.product_id = product_id;
        this.client_id = client_id;
        this.warehouse_id = warehouse_id;
        this.pallet_origin = pallet_origin;
        this.pallet_destination = pallet_destination;
        this.box_origin = box_origin;
        this.batch = batch;
        this.reference = reference;
        this.user_id = user_id;
        this.created_at = created_at;
        this.c_name = client_name;
        this.sku = sku;
        this.o_name = origin_name;
        this.d_name = destination_name;
        this.u_name = user_name;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return relocationValidate(this);
    }
}